import { useEffect, useState } from 'react';
import { getAdminMe } from '../api/api';
import { useAuth } from '../context/AuthContext';

let adminCache = { userId: null, isAdmin: false };

export function useAdminAccess() {
  const { user, loading: authLoading } = useAuth();
  const userId = user?.id || user?.user_id || null;
  const [isAdmin, setIsAdmin] = useState(() => (
    userId && adminCache.userId === userId ? adminCache.isAdmin : false
  ));
  const [loading, setLoading] = useState(() => Boolean(userId && adminCache.userId !== userId));

  useEffect(() => {
    if (authLoading) return;

    if (!userId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    if (adminCache.userId === userId) {
      setIsAdmin(adminCache.isAdmin);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    getAdminMe()
      .then((response) => {
        const nextIsAdmin = Boolean(response.data?.is_admin);
        adminCache = { userId, isAdmin: nextIsAdmin };
        if (!cancelled) setIsAdmin(nextIsAdmin);
      })
      .catch(() => {
        adminCache = { userId, isAdmin: false };
        if (!cancelled) setIsAdmin(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [authLoading, userId]);

  return { isAdmin, loading: authLoading || loading };
}

export function clearAdminAccessCache() {
  adminCache = { userId: null, isAdmin: false };
}
